const primaryDark = '#053D69';
const primaryDarkHover = '#666AF1';
const contrastText = '#fff';
const primary = '#0163cc';
const primaryLight = '#f9fafb';
const secondary = '#f94a8e';
const primaryHover = '#639EFB';
const secondaryHover = '#EE70CA';

/**
 * Use a colour with a given opacity (expressed as 2-digit HEX value)
 * @param color = The color to be modified
 * @param opacity = The opacity to apply (ex. '33' = 20%)
 * @returns {*}
 */
export function withOpacity(color='#000', opacity = '') {
    return color.concat(opacity);
}

export default {
    primaryDarkHover,
    primaryDark,
    contrastText,
    primary,
    primaryLight,
    secondary,
    primaryHover,
    secondaryHover,
}